import React from 'react';
import { connect } from 'react-redux';

import Spinner from 'components/Spinner';

import DashboardContainer, {
  GridColumsContainer,
  LeftContainer,
  RightContainer
} from './container';
import MarketNotebooksIndicator from './components/Header';
import MarketNoteBooksComponent from './components/MarketNotebooks';
import MarketInformationsComponent from './components/MarketInformation';
import LastMarketNotebookComponent from './components/LastMarketNotebook';
import CalendarNextSurveysComponent from './components/CalendarNextSurveys';

import { getDashboardData } from 'actions/dashboard';

class Dashboard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      legalNoticePopup: false
    };

    this.refreshData = this.refreshData.bind(this);
  }

  componentDidMount() {
    this.props.getData();
  }

  refreshData() {
    this.props.getData();
  }

  render() {
    const { feedData, tripData, nextTripData, loading } = this.props;
    const { legalNoticePopup } = this.state;

    return (
      <DashboardContainer>
        <div className="headerContainer">
          <MarketNotebooksIndicator />
          <MarketNoteBooksComponent data={tripData} />
        </div>
        <GridColumsContainer legalNoticePopup={legalNoticePopup}>
          <LeftContainer>
            <MarketInformationsComponent data={feedData} />
          </LeftContainer>
          <RightContainer>
            <LastMarketNotebookComponent
              data={tripData}
              onReload={this.refreshData}
            />
            <CalendarNextSurveysComponent data={nextTripData} />
          </RightContainer>
          <Spinner loading={loading} />
        </GridColumsContainer>
      </DashboardContainer>
    );
  }
}

const mapStateToProps = ({ dashboard }) => ({
  ...dashboard
});

const mapDispatchToProps = (dispatch) => ({
  getData: () => dispatch(getDashboardData())
});

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
